const scrollToNext = () => {
    const nav = document.getElementById('nav');
    const hero = document.querySelector('.hero');
    const sibling = hero.nextElementSibling; //Get the first sibling element to the hero.
    const { top } = sibling.getBoundingClientRect(); //Find the top position of the sibling
    const { marginTop } = window.getComputedStyle(sibling); //Get the margin of the sibling
    const offset = nav.offsetHeight + parseInt(marginTop, 10); //Offset calcuated to compensate for floating nav

    window.scrollTo({ top: top + window.pageYOffset - offset, behavior: 'smooth' });
};

const onHeroInit = () => {
    const hintLink = document.querySelector('.hint a');

    if (hintLink) {
        hintLink.addEventListener('click', scrollToNext);
    }
};

export {
    onHeroInit
};
